export const environment = {
    production: true,
    getterLink:"https://getter.test.jo/api",
    govnet:"https://stagingapp.govnet.gov.jo/api",
    oldWebsite:"https://eservices.moin.gov.jo",

    MainPath:"Investment",
    LogoPicSrc:"../../../assets/images/logo2.png",
    backGroundImageSrc:"../../../assets/images/login-background.jpg",
    NameOfProject:"../assets/languages/IsInvesment/",
    UpFooterLogoPicSrc:"../../../assets/images/Moinlogo.png",
    DownFooterLogoPicSrc:"../../../assets/images/moin-logo-white.png",
    Title:"الخدمات الالكترونية - وزارة الاستثمار",
    socialLinks: {
        facebook: "",
        instagram: "",
        linkedin: "",
        twitter: "",
    },
    SectionId: "64ae566b4e3b1454dea0ed6a",

};
